// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"02ba9a06","455":"69531b03","977":"72bf1ff5"}[chunkId] + ".chunk.js";
};